module.exports = __webpack_public_path__ + "img/strada-dei-vini-valtellina.6fd9de43.png";